const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://www.istanbulymmo.org.tr',
    gaTrackingId: null,
    trailingSlash: true,
  },
  header: {
    logo: 'https://www.istanbulymmo.org.tr/images/logo_1.png',
    logoLink: 'https://www.istanbulymmo.org.tr/',
    title: "<a href='/'>AKADEMİK PORTAL</a>",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [
      { text: '', link: '' }, 
    ],
    search: {
      enabled: true,
      indexName: 'iymmo-akademi',
      algoliaAppId: "ZE6EFZM94T",
      algoliaSearchKey: "e7910d64230d00d0d8db5f2e6027b38a",
      algoliaAdminKey: "4661f2bb443df285a783e23673ebae4e",
    },
  },
  sidebar: {
    forcedNavOrder: [

    ],
    collapsedNav: [

    ],
    links: [
      { text: 'iYMMO', link: 'https://istanbulymmo.org.tr' }, 
      { text: 'ONLINE', link: 'https://www.istanbulymmo.org.tr/Online/' }
    ], // En alt links
    frontline: false,
    ignoreIndex: true, // açılış sayfasını side bardan kaldır.
    title: "<a href='https://www.istanbulymmo.org.tr/'>iYMMO</a><div class='greenCircle'></div><a href='/'>Portal</a><div class='greenCircle'></div><a href='#'>Syf.Başı</a>",
  },
  siteMetadata: {
    title: 'Akademik Dokuman Portal | İYMMO',
    description: 'İstanbul Yeminli Mali Müşavirler Odası akademik ağırlıklı dokuman paylaşım portalı ',
    ogImage: null,
    docsLocation: '',
    favicon: 'https://www.istanbulymmo.org.tr/images/favicon.ico',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Akademik Dokuman Portal | İYMMO',
      short_name: 'İYMMO-DOCS',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: '/src/logo.png',
          sizes: `84x57`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
